// @inheritedComponent Tooltip

import React from "react";
import PropTypes from "prop-types";
import { emphasize, styled } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import { capitalize } from "@mui/material/utils";

const FabContainer = styled("div")({
  margin: "0 4px 8px"
});

const StyledFab = styled(Fab, {
  shouldForwardProp: prop => prop !== "open"
})(({ theme, open }) => ({
  margin: 0,
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  "&:hover": {
    backgroundColor: emphasize(theme.palette.background.paper, 0.15)
  },
  transition: `${theme.transitions.create("transform", {
    duration: theme.transitions.duration.shorter
  })}, opacity 0.8s`,
  opacity: 1,
  ...(!open && {
    opacity: 0,
    transform: "scale(0)"
  })
}));

const InternalSpeedDialAction = function _SpeedDialAction(props, ref) {
  const {
    className,
    delay = 0,
    FabProps = {},
    icon,
    id,
    open,
    TooltipClasses,
    tooltipOpen: tooltipOpenProp = false,
    tooltipPlacement = "left",
    tooltipTitle,
    ...other
  } = props;

  const [tooltipOpen, setTooltipOpen] = React.useState(tooltipOpenProp);

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  const handleTooltipOpen = () => {
    setTooltipOpen(true);
  };

  const transitionStyle = { transitionDelay: `${delay}ms` };

  const fab = (
    <StyledFab
      size="small"
      className={className}
      open={open}
      tabIndex={-1}
      role="menuitem"
      aria-describedby={`${id}-label`}
      {...FabProps}
      style={{
        ...transitionStyle,
        ...FabProps.style
      }}
    >
      {icon}
    </StyledFab>
  );

  // if (tooltipOpenProp) {
  //   return (
  //     <span
  //       id={id}
  //       ref={ref}
  //       className={clsx(
  //         classes.staticTooltip,
  //         !open && classes.staticTooltipClosed,
  //         classes[`tooltipPlacement${capitalize(tooltipPlacement)}`]
  //       )}
  //       {...other}
  //     >
  //       <span
  //         style={transitionStyle}
  //         id={`${id}-label`}
  //         className={classes.staticTooltipLabel}
  //       >
  //         {tooltipTitle}
  //       </span>
  //       {fab}
  //     </span>
  //   );
  // }

  return (
    <Tooltip
      id={id}
      ref={ref}
      title={tooltipTitle}
      placement={tooltipPlacement}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      open={tooltipOpenProp ? open : open && tooltipOpen}
      classes={TooltipClasses}
      {...other}
    >
      <FabContainer>{fab}</FabContainer>
    </Tooltip>
  );
};

const SpeedDialAction = React.forwardRef(InternalSpeedDialAction);

SpeedDialAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   */
  delay: PropTypes.number,
  /**
   * Props applied to the [`Fab`](/api/fab/) component.
   */
  FabProps: PropTypes.object,
  /**
   * The Icon to display in the SpeedDial Fab.
   */
  icon: PropTypes.node,
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * @ignore
   */
  open: PropTypes.bool,
  /**
   * Classes applied to the [`Tooltip`](/api/tooltip/) element.
   */
  TooltipClasses: PropTypes.object,
  /**
   * Make the tooltip always visible when the SpeedDial is open.
   */
  tooltipOpen: PropTypes.bool,
  /**
   * Placement of the tooltip.
   */
  tooltipPlacement: PropTypes.oneOf([
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "left",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top"
  ]),
  /**
   * Label to display in the tooltip.
   */
  tooltipTitle: PropTypes.node
};

export default SpeedDialAction;
